import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { media } from 'src/media'

import { UserStore } from 'src/store/UserStore'

const Root = styled.div`
  font-family: var(--first-second);
  font-weight: 400;
  display: flex;
  justify-content: center;
  margin: 96px auto;
  max-width: 1120px;

  ${media.laptop`
    margin: 68px auto;
  `}

  ${media.tablet`
    margin: 48px auto;
    max-width: 672px;
  `}

  ${media.mobile`
    margin: 48px auto;
    max-width: 320px;
  `}
`

const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1120px;
  width: 100%;
  height: 416px;
  background: var(--color-black);
  border-radius: 500px;
  font-size: 160px;
  line-height: 100%;
  color: var(--color-white);
  text-align: center;
  border: none;
  text-decoration: none;

  :hover {
    cursor: pointer;
    animation: animate infinite 1s;
  }

  @keyframes animate {
    from {
      background: no-repeat url(/assets/1step.webp);
      background-size: cover;
    }
    31% {
      background: no-repeat url(/assets/1step.webp);
      background-size: cover;
    }
    32% {
      background: no-repeat url(/assets/2step.webp);
      background-size: cover;
    }
    63% {
      background: no-repeat url(/assets/2step.webp);
      background-size: cover;
    }
    64% {
      background: no-repeat url(/assets/3step.webp);
      background-size: cover;
    }
    to {
      background: no-repeat url(/assets/3step.webp);
      background-size: cover;
    }
  }
  ${media.laptop`
    width: 100%;
    height: 256px;
    font-size: 96px;
  `}

  ${media.tablet`
    height: 112px;
    font-size: 44px;

    :hover {
      animation: none;
    }

    :active {
      background: var(--color-sunrise);
      outline: none;
    }
  `}

  ${media.mobile`
    height: 106px;
    font-size: 38px;
  `}
`

interface IProps {
  isIOS?: boolean
}

export const HeroButton: React.FC<IProps> = observer((props) => {
  const { isIOS } = props
  return (
    <Root>
      {window.innerWidth < 768 && !UserStore.user && !isIOS ? (
        <Button href="/login">Get started</Button>
      ) : (
        <Button
          id="106"
          href={
            isIOS
              ? `https://apps.apple.com/us/app/breathhh/id6444698538`
              : `https://chrome.google.com/webstore/detail/breathhh/niipedbmjiopjpmjcpigiflabghcckeo`
          }
        >
          Get started
        </Button>
      )}
    </Root>
  )
})
